import React, {Component} from 'react';
import FloatWindow from './FloatWindow';
import OutlineWindow from './OutlineWindow'


class FloatWindowLayout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mousePos:{
                x:0,
                y:0
            },
            refPos:{
                x:0,
                y:0
            },  
            EditFloatWindowPos:{
                x:0,
                y:0
            },
            needMousePos:false,
            containerExtending:{
                status:false,
            },
            containerDragging:{
                status:false,
            },
            imageContainerPos:{
                x:0,
                y:0
            }
        }
        this.openTempFile = React.createRef()
        this.scrollContainerLayout = React.createRef()
        
    }

    componentDidMount(){

    }

    componentDidUpdate(preProps,preState){

    }

    componentWillUnmount(){

    }

    onContainerExtending = (msg)=>{
        //console.log('ControllerUnitLayout onContainerExtending')

        if(msg.containerExtending)
        {
   
                this.setState({
                    containerExtending:{
                        status:msg.containerExtending,
                    },
                    needMousePos:true,
                })
        }
        else
        {
            if(msg.conID === 1)
            {
                this.setState({
                    containerExtending:{
                        status:false,
                    },
                    needMousePos:false,
                    mousePos:{
                        x:0,
                        y:0
                    },
                })
                //console.log("D1")
                this.props.getImageContainerSize(msg.size)
            }
            else if(msg.conID === 2)
            {
                this.setState({
                    containerExtending:{
                        status:false,
                    },
                    needMousePos:false,
                    mousePos:{
                        x:0,
                        y:0
                    },
                })
            }
        }
    }

    onContainerDragging = (msg) => {

        if(msg.containerDragging)
        {
            this.setState({
                containerDragging:{
                    status:msg.containerDragging,     
                },
                needMousePos:true,
            })         
        }
        else
        {        
            this.setState({          
                EditFloatWindowPos:msg.position,
                containerDragging:{
                    status:false,
                },
                needMousePos:false,
                mousePos:{
                    x:0,
                    y:0
                },
                imageContainerPos:msg.position
            },()=>{
                this.props.getFloatWindowPos(msg.position)
            })
        }
    }

  
    onMouseMove=(e)=>{
        //console.log("FloatWindowLayout onMouseMove...")
        if(this.state.needMousePos)
        { 
            this.setState({
                mousePos:{
                    x:e.clientX,
                    y:e.clientY
                },
            })
        }
    }

    getDynamicImageSize=(msg)=>{
        this.props.getDynamicImageSize(msg)
    }



    render(){
        //console.log("FloatWindowLayout render...")
        //console.log(this.props.imageContainerSize)
        let FloatWindowStyle = {
            width:this.props.originalImageSize.width,
            height:this.props.originalImageSize.height,
            position:"relative",
            outline:"3px dashed #ff0000",
            outlineOffset:"-3px"
            //backgroundColor:"gray",
            //opacity:"20"
        }

     
        return (
            <div style={FloatWindowStyle} ref={(scrollContainerLayout)=>{this.scrollContainerLayout=scrollContainerLayout}} onMouseMove={this.onMouseMove} >                     
               <FloatWindow  initialPos={this.props.imageContainerPos} initialSize={this.props.imageContainerSize} dynamicImageSize={this.props.dynamicImageSize} mousePos={this.state.mousePos} containerExtending={this.onContainerExtending} containerDragging={this.onContainerDragging}/>
               <OutlineWindow originalImageSize={this.props.originalImageSize} dynamicImageSize={this.props.dynamicImageSize} mousePos={this.state.mousePos} containerExtending={this.onContainerExtending} getDynamicImageSize={this.getDynamicImageSize}/>
            </div>
        )  
    }
}

export default FloatWindowLayout